import * as React from 'react';
import { useState, useRef } from 'react';
import { Autosuggest, FormField } from '@amzn/awsui-components-react-v3';
import { getEmployeeSuggestions } from '../../actions/employee.action';
import { DropdownStatusProps } from '@amzn/awsui-components-react-v3/polaris/internal/components/dropdown-status';

export const EmployeeSuggestions = (props: {
    onSelect: (selected: {alias: string; name: string}) => void;
    value: string;
}) => {
    const [value, setValue] = useState(props.value);
    const [options, setOptions] = useState<any[]>([]);
    const [statusText, setStatusText] = useState("");
    const [statusType, setStatusType] = useState<DropdownStatusProps.StatusType>();
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    
    const formatSuggestions = (suggestions: any[]) => {
        return suggestions
            .map(suggestion => suggestion.basicInfo)
            .map(basicInfo => (
                {
                    value: basicInfo.login.toLowerCase(),
                    labelTag: `${basicInfo.lastName}, ${basicInfo.firstName}`,
                    iconUrl: `https://badgephotos.corp.amazon.com/?uid=${basicInfo.login}`,
                    iconAlt: basicInfo.login
                }
            ));
    }

    return (
        <div style={{ position: 'relative' }}>
            <FormField errorText={statusText}>
                <Autosuggest
                    enteredTextLabel={(value) => `Use ${value}`}
                    value={value}
                    filteringType="manual"
                    statusType={statusType}
                    loadingText={"loading"}
                    placeholder="Search by name or alias"
                    empty="start typing to see list of suggestions"
                    options={options}
                    expandToViewport={true}
                    onSelect={(e) => {
                        if (e.detail.value) {
                            // The "Use <text>" entered-text option is not in options; fall back to the typed value
                            const selectedOption = options.find((o) => o.value === e.detail.value);
                            props.onSelect({
                                alias: e.detail.value,
                                name: selectedOption?.labelTag ?? e.detail.value
                            })
                        }
                    }}
                    onChange={(e) => {
                        // Clear any existing timeout
                        if (timeoutRef.current) {
                            clearTimeout(timeoutRef.current);
                        }
                        
                        if (e.detail.value) {
                            setValue(e.detail.value)
                            
                            // Capture the current value to avoid closure issues
                            const searchValue = e.detail.value;
                            
                            // Wait 0.5 seconds before calling getEmployeeSuggestions
                            timeoutRef.current = setTimeout(() => {
                                getEmployeeSuggestions(searchValue)
                                    .then(response => {
                                        if (response && response.data && response.data.records) {
                                            setOptions(formatSuggestions(response.data.records));
                                        } else {
                                            setOptions([]);
                                        }
                                    })
                                    .catch((error) => {
                                        console.error('Error fetching employees:', error);
                                        setStatusType("error");
                                        setStatusText("Error fetching employees. Continue typing to try again");
                                    })
                            }, 500);
                        } else {
                            setValue("");
                            setOptions([]);
                        }
                    }}
                    onBlur={() => setValue(props.value)}
                />
            </FormField>
        </div>
    )
}